import { render, staticRenderFns } from "./BaseIndicatorDot.vue?vue&type=template&id=18f9b14c&"
import script from "./BaseIndicatorDot.vue?vue&type=script&lang=js&"
export * from "./BaseIndicatorDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports